import { z } from 'zod';

import { ClientSchema } from '@t/api';

export const clientGroupSchema = z.object({
  clients: z.array(ClientSchema),
  description: z.string(),
  name: z.string(),
});

export type AddClientGroupForm = z.infer<typeof clientGroupSchema>;
